import { Component } from '@angular/core';

@Component({
  selector: 'xilo-mono-unauthorized-page',
  templateUrl: './unauthorized-page.component.html',
  styleUrls: ['./unauthorized-page.component.scss'],
})
export class UnauthorizedComponent {}

// This component will soon be moved to the Dashbord Shared Modules